import {Model} from '@vuex-orm/core'
import RoomtypesHasOperationmodesHasAirvolume from '@models/helpers/RoomtypesHasOperationmodesHasAirvolume'
import RoomltmsHasOperationmode from '@models/helpers/RoomltmsHasOperationmodeAt'

export default class OperationmodeAt extends Model {
  static entity = 'operationmodesAt'

  static fields() {
    return {
      id: this.number(null),
      label: this.string(null).nullable(),
      roomtypesHasOperationmodesHasAirvolumes: this.hasMany(RoomtypesHasOperationmodesHasAirvolume, 'operationmodes_id'),
      roomltmsHasOperationmodes: this.hasMany(RoomltmsHasOperationmode, 'operationmodes_id')
    }
  }
}
